@if (isMobile()) {
  <pxc-dressfit-banner
    class="rounded-xl border border-border-secondary bg-background-primary"
    data-testid="dressfit-banner" />
} @else {
  <pxc-dressfit-panel class="min-h-0 flex-1" data-testid="dressfit-panel" />
}
